import { useCourse } from 'presentation/hooks/courses';
import React from 'react';

import './styles.scss';

export const ProgressBox = () => {
    const { course } = useCourse();

    if (course) {
        return (
            <div className="progess-content">
                <div className="progress-percent">
                    <p>Seu progresso</p>
                    <span>{course.progress.percent}%</span>
                </div>

                <div className="progress">
                    <div className="progress-bar bg-success" style={{ width: `${course.progress.percent}%` }}></div>
                </div>

                <small className="text-gray-dark">
                    {course.progress.completedLessons} de {course.progress.totalLessons} aulas concluídas
                </small>
            </div>
        );
    }

    return <span></span>;
};
